<app-chart-layout
    [subtitle]="computedStatistic().description ?? ''"
    [title]="computedStatistic().name">
    <div class="flex flex-row items-center justify-center">
        <div
            class="relative w-full max-w-full overflow-x-auto"
            id="chart">
            <app-base-chart
                [isMapExpanded]="isExpanded()"
                [options]="options()" />

            @if (hoverTitleInformation()) {
                <div class="flex flex-col items-end justify-center pr-6 pb-2">
                    <span
                        class="font-semibold px-2 py-1 rounded text-white text-base"
                        style="text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7)"
                        [style.background-color]="hoverTitleInformationColor()">
                        {{ hoverTitleInformation() }}
                    </span>
                    <p class="text-on-surface text-end">{{ hoverSubtitleInformation() }}</p>
                    <p class="text-on-surface text-end">{{ hoverNameInformation() }}</p>
                </div>
            }
        </div>
    </div>
</app-chart-layout>
